/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Button } from '@mui/material';
import DefaultModal from './DefaultModal';
import { useOneTimePaymentContext } from '../../contexts/OneTimePaymentContext';
import Styles from '../../css/EscrowShortageModal.module.css';
import { numericFormatter } from 'react-number-format';

const EscrowShortageModal = () => {
  const oneTimePaymentContext = useOneTimePaymentContext();

  return (
    <DefaultModal
      open={oneTimePaymentContext.escrowShortageModalOpen}
      onClose={() => oneTimePaymentContext.setEscrowShortageModalOpen(false)}
      title={<h1>Escrow Shortage</h1>}
      content={
        <p className={Styles.label}>
          {`It appears there is an escrow shortage on your account of ${numericFormatter(
            Math.abs(oneTimePaymentContext?.paymentInfo?.totalEscrowShortage ?? 0).toString(),
            {
              thousandSeparator: true,
              prefix: '$',
              decimalScale: 2,
              fixedDecimalScale: true,
            },
          )}.  ` +
            `You can either pay the total as a lump sum or in monthly installments of ${numericFormatter(
              oneTimePaymentContext?.paymentInfo?.escrowShortageMonthlyRepaymentAmt.toString(),
              {
                thousandSeparator: true,
                prefix: '$',
                decimalScale: 2,
                fixedDecimalScale: true,
              },
            )} ` +
            `for ${oneTimePaymentContext?.paymentInfo?.escrowShortageRepayMonths} months.  Please choose your desired option below.`}
        </p>
      }
      footer={
        <div className={Styles.footer}>
          <Button
            variant='contained'
            onClick={() => oneTimePaymentContext.handleMonthlyInstallments()}
            className={Styles.button}
          >
            Monthly Installments
          </Button>
          <Button variant='contained' onClick={() => oneTimePaymentContext.handleLumpSum()} className={Styles.button}>
            Lump Sum
          </Button>
        </div>
      }
    />
  );
};

export default EscrowShortageModal;
